jQuery(function ($) {
  $(".collapse").on("shown.bs.collapse", function () {
    var id = $(this).attr("id");
    $('.text-toggle-qa[data-target="#' + id + '"]').text("閉じる");
  });

  $(".collapse").on("hidden.bs.collapse", function () {
    var id = $(this).attr("id");
    $('.text-toggle-qa[data-target="#' + id + '"]').text("すべて表示");
  });
});
